// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-client-session-bar[data-v-409d3c82]{width:100dvw;position:fixed;height:50px;z-index:5;background:#e8686f;color:#fff!important}.admin-test-client-session-bar[data-v-409d3c82]{background:#ee994a}", ""]);
// Exports
module.exports = exports;
